import { fg } from '@atlassian/jira-feature-gating';

export const isProjectFieldRemoved = () => {
	return (
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('remove-project-id-iviq') &&
		fg('remove-project-new-issue-view-iviq') &&
		fg('remove-issue-types-iviq')
	);
};

const createProjectFragment = () => `
    project(projectKey: $projectKey) {
        ${!fg('remove-project-id-iviq') ? 'id' : ''}
        ${fg('remove-project-new-issue-view-iviq') ? '' : 'newIssueViewLockedIn'}
        ${
					!fg('remove-issue-types-iviq')
						? `issueTypes {
                                id
                                name
                                iconUrl
                                subtask
                            }`
						: ''
				}
        
    }
`;

export default createProjectFragment;
